import Url from '@music/mobile-url';
import { edFetch } from '@music/encrypt-fetch';

edFetch.init();

function fetch(option = {}, pass = false) {
    let url = option.url;
    delete option.url;
    // const hostname1 = option.hostname1 || Url.CurrentHost;
    if (url.indexOf('/') !== 0) {
        url = '/' + url; // eslint-disable-line
    }
    if (typeof option.noCrossOrigin === 'undefined') {
        option.noCrossOrigin = true;
    }

    process.env.NODE_ENV === 'development' && console.log('===pb===', url, option);
    return edFetch(url, option)
        .then(res => res.json())
        .then(res => res.response || res)
        .then((res) => {
            const { code } = res;
            // response code, 只有200是正常的
            if (code >= 200 && code < 300) {
                return res;
            } if (code == 301) {
                location.href = `/login?targetUrl=${encodeURIComponent(location.href)}`;
            } else {
                if (pass) {
                    return res;
                }
                const msg = res.message || res.msg || '加载失败';
                const errMsg = [msg, code];
                throw new Error(errMsg.join('|%|'));
            }
        });
}

// 处理错误方法
function resolveError(error) {
    const { message } = error;
    let msgArr = ['加载失败'];
    if (message) {
        msgArr = message.split('|%|');
    }
    const msg = msgArr[0];
    const code = msgArr[1];
    return { code, msg };
}

const Request = {
    fetch,
    resolveError
};
export default Request;



// WEBPACK FOOTER //
// ./client/util/fetch.js